export default __webpack_public_path__ + "static/media/reservas-bloqueadas.9dd8ce9b.png";